import metricsApi from "./metrics-api";

class APIMetricsService {
  getDataDogData = () => {
    const url = `/metrics`;
    return metricsApi.get(url);
  };
}

export default new APIMetricsService();
